import { Platform, NativeModules } from "react-native";

const getLocale = () => {
  let currentLocale;
  if (Platform.OS === "web") {
    if (navigator.languages != undefined) {
      currentLocale = navigator.languages[0];
    }
    currentLocale = navigator.language;
  } else {
    currentLocale =
      Platform.OS === "ios"
        ? NativeModules.SettingsManager.settings.AppleLocale ||
          NativeModules.SettingsManager.settings.AppleLanguages[0] //iOS 13
        : NativeModules.I18nManager.localeIdentifier;
  }

  return currentLocale;
};

export default getLocale;
